import { StyledBackgroundWrapper } from './StyledBackgroundWrapper';

export default StyledBackgroundWrapper;
